import { render } from "./ShowAttachments.vue?vue&type=template&id=6c5f6e1f"
import script from "./ShowAttachments.vue?vue&type=script&lang=js"
export * from "./ShowAttachments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__